import { Programme } from 'src/dao/core-dao'
import { coreService } from 'src/service/core-service'
import { EventBusActionType, EventBusEntityType, eventBusUtil } from 'src/util/event-bus-util'
import { queryKeys } from 'src/util/query-keys'
import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query'

export type CancelActiveProgrammeVariables = {
  programmeId: string
  programme: Programme
}

export const useCancelActiveProgramme = (): UseMutationResult<void, Error, CancelActiveProgrammeVariables> => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, CancelActiveProgrammeVariables>({
    mutationFn: ({ programmeId }) => coreService.cancelMyProgramme(programmeId),
    onSuccess: (_, { programmeId, programme }) => {
      queryClient.invalidateQueries(queryKeys.suggestedSeries())
      queryClient.invalidateQueries(queryKeys.myStartedProgrammes())
      queryClient.invalidateQueries({ queryKey: queryKeys.myStartedProgrammesFromLibraryPrefix() })
      queryClient.invalidateQueries(queryKeys.completedProgrammeWorkouts(programmeId))
      queryClient.invalidateQueries(queryKeys.programme(programmeId))
      queryClient.invalidateQueries(queryKeys.programmeWorkouts(programmeId))
      queryClient.invalidateQueries(queryKeys.programmeWorkoutsAvailability(programmeId))
      queryClient.invalidateQueries(queryKeys.hustlerProgramme(programmeId))

      eventBusUtil().emit({
        entity: EventBusEntityType.PROGRAMME,
        action: EventBusActionType.CANCEL,
        meta: { programme },
      })
    },
  })
}
